import { TableRow } from "@mcleod/components";
import { AutogenLayoutMobileCommFormList } from "./autogen/AutogenLayoutMobileCommFormList";

export class MobileCommFormList extends AutogenLayoutMobileCommFormList {
    async onLoad() {
        this.tableMCForm.overrideUrlParams = (selectedRow: TableRow) => {
            return {
                key: selectedRow.data.get("id"),
                formType: selectedRow.data.get("form_type", selectedRow.data.get("form_type")),
                mcControlId: selectedRow.data.get("mc_control_id", selectedRow.data.get("mc_control_id")),
            };
        }
    }
}
